import { render, staticRenderFns } from "./ProjectRoleBadge.vue?vue&type=template&id=267811fd&scoped=true&"
import script from "./ProjectRoleBadge.vue?vue&type=script&lang=ts&"
export * from "./ProjectRoleBadge.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectRoleBadge.vue?vue&type=style&index=0&id=267811fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267811fd",
  null
  
)

export default component.exports